import { Select as UISelect } from "@webmotors/eleanor-ui";
import type { SelectHTMLAttributes } from "react";
import { Text } from "../text";
import styles from "./select.module.css";

export type SelectOption = {
  value: string | number;
  text: string;
};

export interface SelectProps
  extends Omit<
    SelectHTMLAttributes<HTMLSelectElement>,
    "options" | "value" | "onChange" | "size" | "onBlur"
  > {
  options: SelectOption[];
  value: SelectOption[];
  multipleSelection?: boolean;
  canShowClearFilter?: boolean;
  label?: string;
  placeholder?: string;
  auxiliarText?: string;
  enableSearch?: boolean;
  onChange: (value: SelectOption[]) => void;
  disabled?: boolean;
  required?: boolean;
  hasError?: boolean;
  className?: string;
  size?: "small" | "medium" | "large";
  onBlur?: (event: React.FocusEvent<HTMLDivElement>) => void;
  errorMessage?: string;
}

export function Select({ ...props }: SelectProps) {
  const hasError = Boolean(props.errorMessage);
  return (
    <>
      <UISelect {...props} hasError={hasError} />
      {
        hasError && (
          <Text
            className={styles.ErrorMessage}
            data-testid="error-message"
          >
            {props.errorMessage}
          </Text>
        )
      }
    </>
  );
}
